export default __webpack_public_path__ + "static/media/infra-4.63337461.webp";